import InputWizard from '../features/InputWizard'

export default function CreatePage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <InputWizard />
    </div>
  )
}
